var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled from 'styled-components';
import isNumber from 'lodash/isNumber';
import Typography from '../Typography';
import TypographySkeleton from '../Skeleton/Typography';
import { getSpacingSelector, paletteDividerSelector } from '@signal/theme/selectors';
export var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: auto;\n"])));
export var Section = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", "px\n    0;\n  border-bottom: 1px solid ", ";\n"])), function (props) {
  return getSpacingSelector(isNumber(props.sectionSpacing) ? props.sectionSpacing : 2)(props);
}, paletteDividerSelector);
export var SectionSkeleton = styled(Section)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: ", "px;\n"])), function (props) {
  return getSpacingSelector(isNumber(props.sectionSpacing) ? props.sectionSpacing : 2)(props);
});
export var LabelWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return props.alignRight ? "\n    display: flex;\n    justify-content: flex-end;\n    padding-right: ".concat(getSpacingSelector(0.5)(props), "px;\n    width: 100%;") : '';
});
export var Label = styled(function (_ref) {
  var alignRight = _ref.alignRight,
      rest = _objectWithoutProperties(_ref, ["alignRight"]);

  return /*#__PURE__*/React.createElement(Typography, rest);
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var margin = _ref2.margin;
  return margin ? "margin: ".concat(margin, ";") : '';
});
export var LabelSkeleton = Label.withComponent(TypographySkeleton);
export var Metric = styled(Typography)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
export var MetricSkeleton = Metric.withComponent(TypographySkeleton);
export var MetricWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  ", "\n"])), function (props) {
  return props.alignRight && props.metricWidth ? "\n    flex-shrink: 0;\n    width: ".concat(props.metricWidth, "px") : '';
});
export var Heading = styled(Typography).attrs(function () {
  return {
    variant: 'body4',
    color: 'textDark'
  };
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([""])));
export var HeadingSkeleton = styled(Heading.withComponent(TypographySkeleton)).attrs(function () {
  return {
    color: 'skeletonDark'
  };
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([""])));